// Description: Third step of the campaign creation page
// Updated: 25/09/2025
// Author: Simon Franklin

// React
import React from 'react'

// Material UI Components
import { FormControl, FormLabel, Button } from '@mui/material';
import ListsModal from './ListsModal';
import StatusIcon from '../../../components/StatusLabel/StatusIcon';
import StatusLabel from '../../../components/StatusLabel/StatusLabel';

const Step3 = ({ formState, error, setError, updateFieldValue, lists }) => {
  const [openModal, setOpenModal] = React.useState(false);

  const activeColumns = [
    {
      field: 'icon',
      headerName: '',
      width: 80,
      renderCell: (params) => <StatusIcon status={params.value} />,
      sortable: false,
    },
    {
      field: 'title',
      headerName: 'Título',
      flex: 1,
    },
    {
      field: 'desc',
      headerName: 'Descrição',
      flex: 1.5,
    },
    {
      field: 'type',
      headerName: 'Tipo',
      flex: 1,
      renderCell: (params) => <StatusLabel status={params.value} usingOnTable />
    }
  ];

  const selectedList = lists !== null && formState["Selecionar Listagem"] !== "" ? lists.filter((l) => l.id === formState["Selecionar Listagem"])[0] : null

  return (
    <div>
      <FormControl sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
        <FormLabel style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Selecionar Listagem"] === true ? "red" : "#000", fontSize: "14px" }}>
          Selecionar Listagem
        </FormLabel>

        {
          formState["Selecionar Listagem"] === "" ? (
            <p>
              -- Nenhuma Listagem Selecionada --
            </p>
          ) : (
            <>
              <p><strong>Título:</strong> {selectedList?.title}</p>
              <p><strong>Descrição:</strong> {selectedList?.desc}</p>
            </>
          )
        }

        <Button onClick={() => setOpenModal(true)} variant="contained" sx={{ height: "39px", width: "267px", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "16px" }}>
          Selecionar Listagem
        </Button>
      </FormControl>

      <ListsModal lists={lists} open={openModal} updateFieldValue={updateFieldValue} onClose={() => setOpenModal(false)} title={"Selecione uma listagem"} field={"Selecionar Listagem"} activeColumns={activeColumns} setError={setError} formState={formState} currentStep={2} />
    </div>
  )
}

export default Step3